import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { Listing } from './types/Listing';

interface Query {
  minimumStayMonths?: number;
}

export type ListingBookablePeriodsResponse = Required<
  Pick<Listing, 'bookablePeriods' | 'minimumStayMonths' | 'maxBookableDays'>
> & {
  count: number;
};

export default (makeCall: MakeCall) => (listingId: number, query?: Query) =>
  makeCall<ListingBookablePeriodsResponse>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/bookable-periods`,
    {
      query,
    },
  );
